// AWS Amplify Configuration
// This file will be auto-generated after CloudFormation deployment
// Or manually configure with environment variables

export const awsConfig = {
  Auth: {
    region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
    userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
    userPoolWebClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || '',

    oauth: {
      domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: import.meta.env.VITE_REDIRECT_SIGN_IN || 'http://localhost:3000/callback',
      redirectSignOut: import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:3000/logout',
      responseType: 'code',
    }
  },

  API: {
    endpoints: [
      {
        name: 'vibecode-api',
        endpoint: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
        region: import.meta.env.VITE_AWS_REGION || 'us-east-1',
      }
    ]
  }
};

export default awsConfig;
